import "./App.css";
import "./index.css";
import LeadMarketing from "./components/LeadMarketing";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { LeadMarketing2 } from "./components/LeadMarketing2";
import LeadDetails from "./components/LeadDetails";
import ApplicationsDetails from "./components/ApplicationsDetails";
import ApplicationsOverview from "./components/ApplicationsOverview";

import LeadsOverview from "./components/LeadsOverview";
import ApplicationsDetails2 from "./components/ApplicationsDetails2";
import ApplicationsDetails3 from "./components/ApplicationsDetails3";
import PaymentMade from "./components/PaymentMade";
import ActiveUniqueDetails from "./components/ActiveUniqueDetails";
import TotalApplicantCount from "./components/TotalApplicantCount";
import StudentDropouts from "./components/StudentDropouts";
import VisaDetails from "./components/VisaDetails";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./CSS/style.scss";
import Sample from "./components/Sample";
import Sample2 from "./components/Sample2";
import SampleEx from "./components/SampleEx";
import SampleOneMore from "./components/SampleOneMore";
import LoginPage from "./components/LoginPage";
import React, { useState, useEffect } from "react";

export default function App() {
  return (
    <div
      style={{
        maxHeight: "100%",
        backgroundColor: "#d3d3d3",
        overflow: "hidden",
      }}
    >
      {/*  Header Section */}
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LoginPage />} />

            <Route exact path="/lead-marketing" element={<LeadMarketing />} />
            <Route exact path="/lead-marketing2" element={<LeadMarketing2 />} />
            <Route exact path="/lead-details" element={<LeadDetails />} />
            <Route
              exact
              path="/active-unique-details"
              element={<ActiveUniqueDetails />}
            />
            <Route
              exact
              path="/application-details"
              element={<ApplicationsDetails />}
            />
            <Route
              exact
              path="/application-details2"
              element={<ApplicationsDetails2 />}
            />
            <Route
              exact
              path="/application-details3"
              element={<ApplicationsDetails3 />}
            />
            <Route
              exact
              path="/application-overview"
              element={<ApplicationsOverview />}
            />
            <Route exact path="/leads-overview" element={<LeadsOverview />} />
            <Route exact path="/payment-made" element={<PaymentMade />} />
            <Route
              exact
              path="/student-dropouts"
              element={<StudentDropouts />}
            />
            <Route
              exact
              path="/total-applicant-count"
              element={<TotalApplicantCount />}
            />
            <Route exact path="/visa-details" element={<VisaDetails />} />
            <Route exact path="/sample2" element={<Sample2 />} />
            <Route exact path="/sample" element={<Sample />} />
            <Route exact path="/sampleex" element={<SampleEx />} />
            <Route exact path="/sampleonemore" element={<SampleOneMore />} />
            {/* <Route path="/*" element={<LeadMarketing />} /> */}
          </Routes>
        </BrowserRouter>
    </div>
  );
}


